import React from 'react';
import PropTypes from 'prop-types';
import locationUtils from '../../../../lib/utils/location';
import PhoneUtils from '../../../../lib/utils/phone';
import globalStyles from '../../../globals.scss';
import styles from './Recipient.scss';

const RecipientShow = ({ recipient, readOnly }) => {
  const exists =
    recipient.recipient_first_name ||
    recipient.recipient_last_name ||
    recipient.recipient_company_name ||
    recipient.recipient_phone ||
    recipient.recipient_email ||
    recipient.recipient_address;
  return (
    <div>
      {exists &&
        <div
          className={[styles.header, !readOnly ? styles.headerEdit : ''].join(
            ' '
          )}
        >
          {(recipient.recipient_first_name || recipient.recipient_last_name) &&
            <div>
              <strong>
                {recipient.recipient_first_name} {recipient.recipient_last_name}
              </strong>
            </div>}
          {recipient.recipient_company_name &&
            <div
              style={{
                fontWeight:
                  recipient.recipient_first_name ||
                  recipient.recipient_last_name
                    ? 'normal'
                    : 'bold'
              }}
            >
              {recipient.recipient_company_name}
            </div>}
          {recipient.recipient_address &&
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {recipient.recipient_address}
            </div>}
          {recipient.recipient_email &&
            <div>
              <a href={`mailto:${recipient.recipient_email}`}>
                {recipient.recipient_email}
              </a>
            </div>}
          {recipient.recipient_phone &&
            <div>
              {PhoneUtils.formatPhoneNumber(recipient.recipient_phone)}
            </div>}
        </div>}
      {!exists &&
        !readOnly &&
        <div>
          <div>
            <strong>Client Name</strong>
          </div>
          <div className={globalStyles.subtext}>Company Name</div>
          <div className={globalStyles.subtext}>(555) 555-1212</div>
          <div className={globalStyles.subtext}>info@yourcompany.com</div>
          <div className={globalStyles.subtext}>123 Elm Street</div>
          <div className={globalStyles.subtext}>
            {locationUtils.getLocalityString('San Francisco', 'CA', '94105')}
          </div>
        </div>}
    </div>
  );
};

RecipientShow.propTypes = {
  recipient: PropTypes.object.isRequired,
  readOnly: PropTypes.bool
};

export default RecipientShow;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Recipient/RecipientShow.js